import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,GetImgCertUser_CBack,RespBkMthdMapp,detectEmojisAndSpecialCharacters,
  CallMapMethod_CBack,btnSetColor_CBack} from '../function_lib/common_lib';
//import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';



import defaultPic from '../assets/images/9.png';
import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';

import './ship_particular.css';

let loginUser="";
let userObject="";
let companyName="";
let clsWappCamp;


let totalFileAllow=5;

let objImages = [];
let indexExisting=0;
let arrExistingFiles=[];


let objVideo=[];
let vidIndexExisting=0;
let arrVidExistingFiles=[];

let objPdf=[];
let pdfIndexExisting=0;
let arrPdfExistingFiles=[];

//let genderList=["पु.","म.","बा.","बालि."];
let genderList=["M.","F."];
let castCategoryList=["GEN","OBC","SC","ST"];
class Ship_Particular extends React.Component{
    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stListSessionYear:[],stListClassMaster:[],stListFeeCategory:[]};
      clsWappCamp=this;
    
      }
      getCategories(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getMastersRequest"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"ser_userType",value:$("#ser_userType").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        map.push({name:"get_vendor",value:"yes"});
        //alert(status);
        /*
        if(status!=="0"){
          map.push({name:"status",value:status});
        }
        not required as of now
        */
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getMastersRequest";
        CallMapMethod_CBack(clsWappCamp,map,function(data,msg){
         // alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
               // alert(JSON.stringify(listData.receipt_amount));
                clsWappCamp.setState({ stListSessionYear:listData.ls_session_year,
                  stListClassMaster:listData.ls_class_master,
                stListFeeCategory:listData.ls_fee_category},()=>{
                
                //  clsWappCamp.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                });
              }
        });
      }

//  check file validation
      fileValidation(){
        let allowFile=true;
     let imgCount=objImages.length;
     let vidCount=objVideo.length;
     let pdfCount=objPdf.length;

     let vTotalCount=imgCount+vidCount+pdfCount;
    
     if(vTotalCount>=totalFileAllow){
      alert("Only "+totalFileAllow+" to be allowed .");
      allowFile=false;
     }
     return allowFile;
 }
 //  check file validation     
  rmPdfProc(data){
    
        if(document.getElementById("ref_pdf_"+data)!=null){
          document.getElementById("ref_pdf_"+data).remove();
        }
        
        this.lcRemoveJSON(data,"pdf");
      }    

PdfThumbBack(flImg,flName,fObject,othInfo=""){
  if(!this.fileValidation()){
    return;
  }
  if(flImg==="-10"){
    alert(flName);
    return;
  }
   if(othInfo===""){
    othInfo="nm"+pdfIndexExisting+","+pdfIndexExisting;
  }
  pdfIndexExisting++;
  var arrNmValue=othInfo.split(',');
  //arrExistingFiles.push
  arrPdfExistingFiles[arrNmValue[1]]=arrNmValue[0];
  var strSet = "<div id=\"ref_pdf_"+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-6 lsthumb image_thumb_parent\">" +
  "<i class=\"fa fa-close icon-close _removeBtn"+pdfIndexExisting+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
    "<a class=\"gallery-item\" href=\""+flImg+"\"><img src="+pdfIcon+" /></a>" +
    "</div>";
  
    
  //$("#audios").val("{\"objs\":" + JSON.stringify(objAudio) + "}");
  objPdf.push({ name: arrNmValue[1], value: flImg });
  $("#lsPdf").val("{\"objs\":" + JSON.stringify(objPdf) + "}");
  //alert(strSet);            
  $(".pdfLibThumb").append(strSet);
  if(fObject!==null){
    fObject.val('');
  }

RespBkMthdMapp(clsWappCamp, "_removeBtn"+pdfIndexExisting, "rmPdfProc", "2");
  //imgLibThumb
}      
rmVideoProc(data){
  if(document.getElementById("ref_vid_"+data)!=null){
    document.getElementById("ref_vid_"+data).remove();
  }
  
  this.lcRemoveJSON(data,"video");
}
VideoThumbBack(flImg,flName,fObject,othInfo=""){
  if(!this.fileValidation()){
    return;
  }
  if(flImg==="-10"){
    alert(flName);
    return;
  }

  if(othInfo===""){
    othInfo="nm"+vidIndexExisting+","+vidIndexExisting;
  }
  vidIndexExisting++;
  var arrNmValue=othInfo.split(',');
  //arrExistingFiles.push
  arrVidExistingFiles[arrNmValue[1]]=arrNmValue[0];
  var strSet = "<div id=\"ref_vid_"+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-6 lsthumb image_thumb_parent\">" +
  "<i class=\"fa fa-close icon-close _removeBtn"+vidIndexExisting+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
    "<a class=\"gallery-item\" href=\""+flImg+"\"><img src=\"" + mp3Icon + "\"/></a>" +
    "</div>";
    if(flImg.indexOf("data:video/webm")!=-1 || flImg.indexOf("data:video/mp4")!=-1){
     strSet= "<div id=\"ref_vid_"+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-12 lsthumb image_thumb_parent\">" +
      "<i class=\"fa fa-close icon-close _removeBtn"+vidIndexExisting+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
        "<a class=\"gallery-item\" href=\""+flImg+"\"><img src="+mp4Icon+" /></a>" +
        "</div>";
    }
    
  //$("#audios").val("{\"objs\":" + JSON.stringify(objAudio) + "}");
  objVideo.push({ name: arrNmValue[1], value: flImg });
  $("#lsVideo").val("{\"objs\":" + JSON.stringify(objVideo) + "}");
  //alert(strSet);            
  $(".vidLibThumb").append(strSet);
  if(fObject!==null){
    fObject.val('');
  }

RespBkMthdMapp(clsWappCamp, "_removeBtn"+vidIndexExisting, "rmVideoProc", "2");
  //imgLibThumb
}      
rmFileProc(data){
  
    if(document.getElementById("ref_div_"+data)!=null){
      document.getElementById("ref_div_"+data).remove();
    }
    
    this.lcRemoveJSON(data,"image");
}
/* Loc */
lcRemoveJSON(refKey,fType){
if(fType==="image"){
  var jsonP=JSON.parse($("#lsImages").val());
  var arrJson=jsonP.objs;
  for(var ai=0;ai<arrJson.length;ai++){
    if(arrJson[ai]["name"]===refKey){
      arrJson.splice(ai,1);
      $("#lsImages").val(JSON.stringify(jsonP));
      
      break;
    }
  }
  objImages=arrJson;
  
}else if(fType==="video"){
  var jsonP=JSON.parse($("#lsVideo").val());
  var arrJson=jsonP.objs;
  for(var ai=0;ai<arrJson.length;ai++){
    if(arrJson[ai]["name"]===refKey){
      arrJson.splice(ai,1);
      $("#lsVideo").val(JSON.stringify(jsonP));
      
      break;
    }
  }
  objVideo=arrJson;
}else if(fType==="pdf"){
  var jsonP=JSON.parse($("#lsPdf").val());
  var arrJson=jsonP.objs;
  for(var ai=0;ai<arrJson.length;ai++){
    if(arrJson[ai]["name"]===refKey){
      arrJson.splice(ai,1);
      $("#lsPdf").val(JSON.stringify(jsonP));
      
      break;
    }
  }
  objPdf=arrJson;
}


 
}     
ImageThumbBack(flImg, flName,fObject,othInfo="") {
  
  if(!this.fileValidation()){
    return;
  }

  if(flImg==="-10"){
    alert(flName);
    return;
  }

  if(othInfo===""){
    othInfo="nm"+indexExisting+","+indexExisting;
  }
  indexExisting++;
  var arrNmValue=othInfo.split(',');
  //arrExistingFiles.push
  arrExistingFiles[arrNmValue[1]]=arrNmValue[0];
  var strSet = "<div id=\"ref_div_"+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-6 lsthumb image_thumb_parent\">" +
  "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
    "<a class=\"gallery-item\" href=\""+flImg+"\"><img src=\"" + flImg + "\"/></a>" +
    "</div>";
    if(flImg.indexOf("data:video/webm")!==-1 || flImg.indexOf("data:video/mp4")!==-1){
     strSet= "<div id=\"ref_div_"+arrNmValue[1]+"\" class=\"col-lg-3 col-md-3 col-sm-3 col-12 lsthumb image_thumb_parent\">" +
      "<i class=\"fa fa-close icon-close _removeBtn"+indexExisting+"\" param1=\""+arrNmValue[1]+"\" aria-hidden=\"true\"></i>"+
        "<a class=\"gallery-item\" href=\""+flImg+"\"><video controls type=\"video/mp4\" src=\"" + flImg + "\"/></a>" +
        "</div>";
    }
    
  //$("#audios").val("{\"objs\":" + JSON.stringify(objAudio) + "}");
  objImages.push({ name: arrNmValue[1], value: flImg });
 // alert(objImages.length);
  $("#lsImages").val("{\"objs\":" + JSON.stringify(objImages) + "}");
  //alert(strSet);            
  $(".imgLibThumb").append(strSet);
  if(fObject!==null){
    fObject.val('');
  }
//   $('.gallery-item').magnificPopup({
//     type: 'image',
//     gallery: {
//         enabled: true
//     }
// });
RespBkMthdMapp(clsWappCamp, "_removeBtn"+indexExisting, "rmFileProc", "2");
  //imgLibThumb
      }


saveWappCompaign(){
  //alert("Sending WAPP");
  //alert($("#contact_no").val());
/*
  let checkChar= $("#msg_text").val();
   let result=detectEmojisAndSpecialCharacters(checkChar);
  
if(result.emojis.length!==0 || result.specialCharacters.length!==0){
   alert("Special Characters and Emojis not allowd in text Message");
   return; 
}
*/


//btnSetColor_CBack(clsWappCamp,frmWappCamp,"createPt",function(data,msg))
btnSetColor_CBack(clsWappCamp,"frmAddShipParticular","addShipParticulars",function(checkData,checkMsg){
    //alert(checkData+checkMsg)
    if(checkData===-10){
      alert("Kindly fill required fields");
      return;
    }else if(checkData==="001"){
      Custom_Alert("Successfully Added",checkMsg,true);
        //window.location.reload();
    }else if(checkData==="01") {
      Custom_Alert("Not added",checkMsg,false);
      //alert(checkMsg);
    }
    
  });

  
// Custom_Alert("WAPP CAMPAIGN","<span>Test1</span><span>Test2</span>")
  
 
}

 isFloat(n) {
  let checkNum = false;
  if (Number(n)) {
      checkNum = true;
  } else if (n % 1 !== 0) {
      checkNum = true;
  } else {
      checkNum = false;
  }

  return checkNum;
}
 
componentDidMount(){
    
  this.getCategories();
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].id);


$(".cd_input_change").change(function () {
  let objPreCost = document.getElementById("pre_cost");
  let objOfferPer = document.getElementById("offer_per");
  let objFCost = document.getElementById("txt_cost");

    let valPreCost = 0;
    let valOfferPer = 0;
    let valFCost = 0;

    if (clsWappCamp.isFloat(objPreCost.value.trim())) {
      valPreCost = objPreCost.value.trim();
    }
    if (clsWappCamp.isFloat(objOfferPer.value.trim())) {
      valOfferPer = objOfferPer.value.trim();
    }
    if (clsWappCamp.isFloat(objFCost.value.trim())) {
      valFCost = objFCost.value.trim();
    }

    if(valOfferPer!==0){
      objFCost.value = valPreCost-(valPreCost * valOfferPer / 100).toFixed(2);
    }else{
      objFCost.value=objPreCost.value;
    }



})
}

   render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row">
<div className="col-md-12 col-lg-12"> 
        
<section class="content">
<div class="container-fluid">
<div class="card card-primary">
<div class="card-header">
                                <h3 class="card-title">Ship Particular Master</h3>
                                <a className="btn btn-sm btn-danger float-right" href="../view_ship_particulars">View Ship's Particulars</a>
                            </div>
                            <form class="form-group" id="frmAddShipParticular" name="frmAddShipParticular">
                            
                            
                            
                            <input type="hidden" id="m_type" name="m_type" value={"addShipParticulars"}/>
        <input type="hidden" id="res_func" name="res_func" value={"useit"}/>
            <input type="hidden" id="global_token" name="global_token" value={userObject[0]["id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={userObject[0]["id"]}/>
       
                            {/* <input type="hidden" name="lsImages" id="lsImages" />
                            <input type="hidden" name="lsVideo" id="lsVideo"/>
                            <input type="hidden" name="lsPdf" id="lsPdf"/> */}
                            <div class="card-body">

                              {/* ship particular */}
                              <div class="container ship-particularsss">
        <h2>Ship's Particulars</h2>
        
        
            <div class="section">
                <h4>General Particulars</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="shipName">Ship's name:</label>
                            <input type="text" id="ship_name" name="ship_name" class="required" />
                        </div>
                        <div class="field">
                            <label for="ship_type">Ship type:</label>
                            <input type="text" id="ship_type" name="ship_type" class="required"/>
                        </div>
                        <div class="field">
                            <label for="imo_no">IMO number:</label>
                            <input type="text" id="imo_no" name="imo_no" class="required" />
                        </div>
                        <div class="field">
                            <label for="callSign">Call sign:</label>
                            <input type="text" id="call_sign" name="call_sign" class="required"/>
                        </div>
                        <div class="field">
                            <label for="flag">Flag:</label>
                            <input type="text" id="flag" name="flag" class="required"/>
                        </div>
                        <div class="field">
                            <label for="length_o">Length overall:</label>
                            <input type="text" id="length_o" name="length_o" class="required"/>
                        </div>
                        <div class="field">
                            <label for="breadth">Breadth:</label>
                            <input type="text" id="breadth" name="breadth" class="required"/>
                        </div>
                        <div class="field">
                            <label for="depth">Depth:</label>
                            <input type="text" id="depth" name="depth" />
                        </div>
                        <div class="field">
                            <label for="summer_draft">Summer draft:</label>
                            <input type="text" id="summer_draft" name="summer_draft" />
                        </div>
                        <div class="field">
                            <label for="summer_freeboard">Summer freeboard:</label>
                            <input type="text" id="summer_freeboard" name="summer_freeboard"/>
                        </div>
                        <div class="field">
                            <label for="grossTonnage">Gross tonnage:</label>
                            <input type="text" id="gross_tonnage" name="gross_tonnage"/>
                        </div>
                        <div class="field">
                            <label for="net_tonnage">Net tonnage:</label>
                            <input type="text" id="net_tonnage" name="net_tonnage"/>
                        </div>
                        <div class="field">
                            <label for="dead_weight">Deadweight:</label>
                            <input type="text" id="dead_weight" name="dead_weight"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="light_displacement">Light displacement:</label>
                            <input type="text" id="light_displacement" name="light_displacement"/>
                        </div>
                        <div class="field">
                            <label for="fwa">Fresh water Allowance (FWA):</label>
                            <input type="text" id="fwa" name="fwa"/>
                        </div>
                        <div class="field">
                            <label for="immersionLoadDraft">Immerse on load craft(TPC):</label>
                            <input type="text" id="tcp" name="tcp"/>
                        </div>
                        <div class="field">
                            <label for="mctc">Trimming moment:</label>
                            <input type="text" id="mctc" name="mctc"/>
                        </div>
                        <div class="field">
                            <label for="bale_capacity">Bale capacity:</label>
                            <input type="text" id="bale_capacity" name="bale_capacity"/>
                        </div>
                        <div class="field">
                            <label for="grain_capacity">Grain capacity:</label>
                            <input type="text" id="grain_capacity" name="grain_capacity"/>
                        </div>
                        <div class="field">
                            <label for="liquid_capacity">Liquid capacity:</label>
                            <input type="text" id="liquid_capacity" name="liquid_capacity"/>
                        </div>
                        <div class="field">
                            <label for="refg_capacity">Refrigerated capacity:</label>
                            <input type="text" id="refg_capacity" name="refg_capacity"/>
                        </div>
                        <div class="field">
                            <label for="container_capacity">Container capacity(TEU):</label>
                            <input type="text" id="container_capacity"/>
                        </div>
                        <div class="field">
                            <label for="fresh_water_capacity">Freshwater capacity:</label>
                            <input type="text" id="fresh_water_capacity" name="fresh_water_capacity"/>
                        </div>
                        <div class="field">
                            <label for="daily_f_water_gen">Daily FreshWater Generation:</label>
                            <input type="text" id="daily_f_water_gen" name="daily_f_water_gen"/>
                        </div>
                        <div class="field">
                            <label for="daily_f_water_consp">Daily FreshWater Consumption:</label>
                            <input type="text" id="daily_f_water_consp" name="daily_f_water_consp"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Main Engine Particulars</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="engineType">Engine (type):</label>
                            <input type="text" id="engineType"/>
                        </div>
                        <div class="field">
                            <label for="boilersType">Boilers (type and number):</label>
                            <input type="text" id="boilersType"/>
                        </div>
                        <div class="field">
                            <label for="bunkerCapacity">Bunker capacity:</label>
                            <input type="text" id="bunkerCapacity"/>
                        </div>
                        <div class="field">
                            <label for="dailyConsumption">Daily Consumption:</label>
                            <input type="text" id="dailyConsumption"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="serviceSpeed">Service speed:</label>
                            <input type="text" id="serviceSpeed"/>
                        </div>
                        <div class="field">
                            <label for="mainEngineOutput">Main engine output (kW at rev/min):</label>
                            <input type="text" id="mainEngineOutput"/>
                        </div>
                        <div class="field">
                            <label for="steeringGearType">Type of steering gear:</label>
                            <input type="text" id="steeringGearType"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Mooring Ropes (number/diameter)</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="naturalFiber">Natural fiber:</label>
                            <input type="text" id="naturalFiber"/>
                        </div>
                        <div class="field">
                            <label for="syntheticFiber">Synthetic fiber:</label>
                            <input type="text" id="syntheticFiber"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="wires">Wires:</label>
                            <input type="text" id="wires"/>
                        </div>
                        <div class="field">
                            <label for="towingSpring">Towing spring:</label>
                            <input type="text" id="towingSpring"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Anchors (number of shackles/weights)</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="port">Port:</label>
                            <input type="text" id="port"/>
                        </div>
                        <div class="field">
                            <label for="starboard">Starboard:</label>
                            <input type="text" id="starboard"/>
                        </div>
                        <div class="field">
                            <label for="cableDiameter">Cable (diameter):</label>
                            <input type="text" id="cableDiameter"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="stern">Stern:</label>
                            <input type="text" id="stern"/>
                        </div>
                        <div class="field">
                            <label for="spare">Spare:</label>
                            <input type="text" id="spare"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Life Saving Equipment</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="lifeboatType">Lifeboat type (open/enclosed/free-fall):</label>
                            <input type="text" id="lifeboatType"/>
                        </div>
                        <div class="field">
                            <label for="lifeboatsNumber">Lifeboats (no.):</label>
                            <input type="text" id="lifeboatsNumber"/>
                        </div>
                        <div class="field">
                            <label for="liferaftsNumber">Liferafts (no.):</label>
                            <input type="text" id="liferaftsNumber"/>
                        </div>
                        <div class="field">
                            <label for="lifeboatDimensions">Lifeboat (dimensions):</label>
                            <input type="text" id="lifeboatDimensions"/>
                        </div>
                        <div class="field">
                            <label for="lifeboatCapacityPersons">Lifeboat capacity (persons):</label>
                            <input type="text" id="lifeboatCapacityPersons"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="liferaftCapacity">Liferaft capacity (persons):</label>
                            <input type="text" id="liferaftCapacity"/>
                        </div>
                        <div class="field">
                            <label for="lifeboatFallsDiameter">Lifeboat falls (diameter):</label>
                            <input type="text" id="lifeboatFallsDiameter"/>
                        </div>
                        <div class="field">
                            <label for="lifeboatDavitsType">Lifeboat davits (type):</label>
                            <input type="text" id="lifeboatDavitsType"/>
                        </div>
                        <div class="field">
                            <label for="lifeboysNumber">Lifebuoys (number):</label>
                            <input type="text" id="lifeboysNumber"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Fire Fighting Equipment</h4>
                <div class="fire-section">
                    <strong>Fire Extinguishers (no. & capacity)</strong>
                    <div class="fire-row">
                        <div class="fire-col">
                            <div class="field">
                                <label for="water">Water:</label>
                                <input type="text" id="water"/>
                            </div>
                        </div>
                        <div class="fire-col">
                            <div class="field">
                                <label for="foam">Foam:</label>
                                <input type="text" id="foam"/>
                            </div>
                        </div>
                        <div class="fire-col">
                            <div class="field">
                                <label for="dryPowder">Dry powder:</label>
                                <input type="text" id="dryPowder"/>
                            </div>
                        </div>
                        <div class="fire-col">
                            <div class="field">
                                <label for="co2">CO2:</label>
                                <input type="text" id="co2"/>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="fireHoses">Fire hoses (no. & size):</label>
                            <input type="text" id="fireHoses"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="fixedFireSystem">Fixed fire-fighting system:</label>
                            <input type="text" id="fixedFireSystem"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="scbaMake">SCBA (no. & make):</label>
                            <input type="text" id="scbaMake"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Cargo Handling Equipment</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="derricksCranes">Derricks/Cranes (no. & SWL):</label>
                            <input type="text" id="derricksCranes"/>
                        </div>
                        <div class="field">
                            <label for="winchesType">Winches (type):</label>
                            <input type="text" id="winchesType"/>
                        </div>
                        <div class="field">
                            <label for="otherCargoEquipment">Other cargo equipment:</label>
                            <input type="text" id="otherCargoEquipment"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="ballastTanks">Ballast tanks (no. & capacity):</label>
                            <input type="text" id="ballastTanks"/>
                        </div>
                        <div class="field">
                            <label for="cargoTanks">Cargo tanks (no. & capacity):</label>
                            <input type="text" id="cargoTanks"/>
                        </div>
                        <div class="field">
                            <label for="cargoPumps">Cargo pumps (no. & capacity):</label>
                            <input type="text" id="cargoPumps"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <h4>Navigational & Communication Equipment</h4>
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <label for="radarArpa">Radar/ARPA:</label>
                            <input type="text" id="radarArpa"/>
                        </div>
                        <div class="field">
                            <label for="log">Log:</label>
                            <input type="text" id="log"/>
                        </div>
                        <div class="field">
                            <label for="gps">GPS:</label>
                            <input type="text" id="gps"/>
                        </div>
                        <div class="field">
                            <label for="magneticCompass">Magnetic compass:</label>
                            <input type="text" id="magneticCompass"/>
                        </div>
                        <div class="field">
                            <label for="gyroCompass">Gyro compass:</label>
                            <input type="text" id="gyroCompass"/>
                        </div>
                        <div class="field">
                            <label for="echoSounder">Echo sounder:</label>
                            <input type="text" id="echoSounder"/>
                        </div>
                        <div class="field">
                            <label for="autoPilot">Auto-pilot:</label>
                            <input type="text" id="autoPilot"/>
                        </div>
                        <div class="field">
                            <label for="vhf">VHF:</label>
                            <input type="text" id="vhf"/>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <label for="mfhf">MF/HF:</label>
                            <input type="text" id="mfhf"/>
                        </div>
                        <div class="field">
                            <label for="satBSatC">SAT B/SAT C:</label>
                            <input type="text" id="satBSatC"/>
                        </div>
                        <div class="field">
                            <label for="ecdis">ECDIS:</label>
                            <input type="text" id="ecdis"/>
                        </div>
                        <div class="field">
                            <label for="sartEpirb">SART/EPIRB:</label>
                            <input type="text" id="sartEpirb"/>
                        </div>
                        <div class="field">
                            <label for="navtex">Navtex:</label>
                            <input type="text" id="navtex"/>
                        </div>
                        <div class="field">
                            <label for="aisLrit">AIS/LRIT:</label>
                            <input type="text" id="aisLrit"/>
                        </div>
                        <div class="field">
                            <label for="vdr">VDR:</label>
                            <input type="text" id="vdr"/>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div class="buttons">
                <button type="submit" class="submit-btn">Submit</button>
                <button type="reset" class="reset-btn">Reset</button>
            </div> */}
        
    </div>
                              {/* end of ship particular */}
                              
                            {/* end of other details */}                           

                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                                <div class="row">
                                    <div class="col-12">
                                      
                                        <div class="form-group">
                                        <center>
                                            <div class="input-group input-group-sm" style={{"justify-content":"center"}}>
                                                <button type="button" onClick={()=>this.saveWappCompaign()} class="btn btn-primary">Save and Review</button>
                                            </div>
                                        </center>
                                        </div>
                                        
                                    </div>
                                </div>
                                </div>
                            </form>
    </div>
    </div>
</section>
      
</div>
    
</div>
</div>
</div>
<Alert_Content/>
<Footer/>

          </div>)
      }
}
export default Ship_Particular;